// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pay_wrapper__3Ubrt","main":"Pay_main__wWlPu","btn":"Pay_btn__1Bc2h"};